import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent {

}
